module.exports = __webpack_public_path__ + "img/LogIn.1c2c41dd.webp";